import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=684ce591&scoped=true"
import script from "./CloseIcon.vue?vue&type=script&lang=js"
export * from "./CloseIcon.vue?vue&type=script&lang=js"
import style0 from "./CloseIcon.vue?vue&type=style&index=0&id=684ce591&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684ce591",
  null
  
)

export default component.exports